import React from "react";
import StorefrontLayout from "../components/storefront/Layout";
import YMMTSelector from "../components/storefront/YMMTSelector";
import Breadcrumbs, { breadcrumbJsonLd } from "../components/storefront/Breadcrumbs";
import { useSeo } from "../lib/seo";

export default function FindMyVehicle() {
  const crumbs = [{ label: "Home", to: "/" }, { label: "Find My Vehicle" }];
  useSeo({
    title: "Find Side Mirrors & Windshields by Vehicle | Lecis Auto Glass",
    description: "Select your Year, Make, Model and Trim to find compatible side mirrors and windshields. Fitment-verified, shipped nationwide.",
    canonicalPath: "/find-my-vehicle",
    jsonLd: { breadcrumb: breadcrumbJsonLd(crumbs) },
  });
  return (
    <StorefrontLayout>
      <div className="max-w-4xl mx-auto px-6 lg:px-12 py-16" data-testid="find-my-vehicle-page">
        <Breadcrumbs items={crumbs} />
        <div className="text-[10px] uppercase tracking-[0.3em] text-red-500 font-bold mb-3">Find your fit</div>
        <h1 className="font-display text-4xl md:text-6xl tracking-tighter font-medium mb-4">Find My Vehicle</h1>
        <p className="text-zinc-400 max-w-2xl text-base leading-relaxed mb-10">
          Select your Year, Make, Model and Trim below. We'll show every compatible side mirror and windshield we carry — fitment-verified, shipped nationwide.
        </p>
        <YMMTSelector variant="hero" />
      </div>
    </StorefrontLayout>
  );
}
